module.exports = __webpack_public_path__ + "img/logo-white.58790f22.svg";